import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 复制插件
import VueClipboard from 'vue-clipboard2'
import { Toast } from 'vant'
import { Icon } from 'vant'

Vue.use(Icon)
import 'vant/lib/index.css'

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(Toast)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
